import Login from '../views/login';
import ErrorLogout from '../views/error-logout';

import NothingButARouterView from './nothing-but-a-router-view';

import Main from '../views/main/main.vue';
import Catalog from '../views/main/catalog';
import OrderHistory from '../views/main/catalog/order-history';
import Contrats from '../views/main/catalog/contrats';
import Lots from '../views/main/catalog/lots';
import Aliments from '../views/main/catalog/aliments';
import Cart from '../views/main/catalog/cart';
import ConfirmCommande from '../views/main/catalog/cart/confirm-commande';
import ValidPanier from '../views/main/catalog/cart/validation-panier';
import CommandesEnCours from '../views/main/commandes-en-cours';
import Mention from '../views/main/infos/mentions';
import ConditionsVente from '../views/main/infos/conditions-vente';
import PolitiqueConfidentialite from '../views/main/infos/politique-confidentialite';
import Contacts from '../views/main/infos/contacts';
import SelectionTiers from '../views/admin/connect-as/selection-tiers';
import EditArticlesCommandables from '../views/main/admin/articles-commandables/edit';
import Admin from '../views/admin';
import Parametres from '../views/admin/parametres';
import ParamMessages from '../views/admin/messages';

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: 'Login' }
  },
  {
    path: '/error-logout',
    name: 'error-logout',
    component: ErrorLogout,
    props: (route) => (route.query),
    meta: { title: 'Erreur' }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { title: 'Admin' },
    children: [
      {
        path: 'connect-as/selection-tiers',
        name: 'admin.connect_as.selection_tiers',
        component: SelectionTiers,
        meta: { title: 'Selection tiers' }
      },
      {
        path: 'parametres',
        name: 'admin.parametres',
        component: Parametres,
        meta: { title: 'Paramètres' }
      },
      {
        path: 'banniere-messages',
        name: 'admin.messages',
        component: ParamMessages,
        meta: { title: 'Bannière de message' }
      }

    ]
  },
  {
    path: '/',
    name: 'main',
    component: Main,
    children: [
      {
        path: 'catalog',
        name: 'main.catalog',
        redirect: { name: 'main.catalog.order_history' },
        component: Catalog,
        children: [
          { path: 'order_history', name: 'main.catalog.order_history', component: OrderHistory, meta: { title: 'Historique des livraisons' } },
          { path: 'contrats', name: 'main.catalog.contrats', component: Contrats, meta: { title: 'Mes contrats' } },
          { path: 'lots', name: 'main.catalog.lots', component: Lots, props: (route) => (route.query), meta: { title: 'Mes lots' } },
          { path: 'aliments', name: 'main.catalog.aliments', component: Aliments, meta: { title: 'Aliments' } },
          {
            path: 'cart',
            name: 'main.catalog.cart',
            redirect: { name: 'main.catalog.cart.view' },
            component: NothingButARouterView,
            meta: { title: 'Mon panier' },
            children: [
              { path: 'view', name: 'main.catalog.cart.view', component: Cart },
              { path: 'validPanier', name: 'main.catalog.cart.validPanier', component: ValidPanier, meta: { title: 'Règlement' } },
              { path: 'confirm', name: 'main.catalog.cart.confirm', component: ConfirmCommande, props: (route) => (route.query), meta: { title: 'Confirmation de commande' } }
            ]
          }
        ]
      },
      {
        path: 'commandes-en-cours',
        name: 'main.infos.commandesEnCours',
        component: CommandesEnCours,
        meta: { title: 'Commandes en cours' }
      },
      {
        path: 'Mention',
        name: 'main.infos',
        redirect: { name: 'main.infos.conditions-vente' },
        component: NothingButARouterView,
        meta: { title: 'Informations' },
        children: [
          {
            path: 'conditionsVente',
            name: 'main.infos.conditionsVente',
            component: ConditionsVente,
            meta: { title: 'CGU' }
          },
          {
            path: 'mention',
            name: 'main.infos.mention',
            component: Mention,
            meta: { title: 'Mentions légales' }
          },
          {
            path: 'politique',
            name: 'main.infos.politiqueConfidentialite',
            component: PolitiqueConfidentialite,
            meta: { title: 'Politique de confidentialité' }
          },
          {
            path: 'contacts',
            name: 'main.infos.contacts',
            component: Contacts,
            meta: { title: 'Contacts' }
          }
        ]
      },
      {
        path: 'admin',
        name: 'main.admin',
        component: NothingButARouterView,
        children: [
          {
            path: 'edit-articles',
            name: 'main.admin.edit_articles',
            component: EditArticlesCommandables,
            meta: { title: 'Administration - Modification des articles commandables' }
          }
        ]
      }
    ]
  }
];
